import { create } from "zustand";
import { attemptByEngagements, callAnalytics, engagementReport, escalationAnalytics, escalations, repAssignment, salesDashboard } from "../api_layer/api";

export const useAdminEscalations = create((set) => ({
  escalationData: [],
  escalationLoading: false,
  error: null,
  fetchEscalationsData: async () => {
    try {
      set({ escalationLoading: true, error: null });
      const response = await escalations();
      set({ escalationData: response.data, escalationLoading: false });
    } catch (error) {
      set({ error: error.message, escalationLoading: false });
    }
  },
}));

export const useSalesV2 = create((set) => ({
  salesData: [],
  salesLoading: false,
  error: null,
  fetchSalesData: async (sd, ed) => {
    try {
      set({ salesLoading: true, error: null });
      const response = await salesDashboard(sd, ed);
      set({ salesData: response.data, salesLoading: false });
    } catch (error) {
      set({ error: error.message, salesLoading: false });
    }
  },
}));

export const usePostSalesV2 = create((set) => ({
  callAnalyticsData: [],
  engagementReportData:[],
  escalationAnalyticsData:[],
  repData:[],
  p1CallData:[],
  w1CallData:[],
  w2CallData:[],
  w3CallData:[],
  w4CallData:[],
  w5CallData:[],
  w6CallData:[],
  callLoading:false,
  postCallsLoading: false,
  engagementLoading:false,
  escalationLoading : false ,
  repLoading  : false   ,
  error: null,
  fetchCallAnalyticsData: async (sd, ed) => {
    try {
      set({ postCallsLoading: true, error: null });
      const response = await callAnalytics(sd, ed);
      set({ salesData: response.data, postCallsLoading: false });
    } catch (error) {
      set({ error: error.message, postCallsLoading: false });
    }
  },
  fetchEngagementReport: async (sd, ed) => {
    try {
      set({ postCallsLoading: true, error: null });
      const response = await engagementReport(sd, ed);
      set({ engagementReportData: response.data, postCallsLoading: false });
    } catch (error) {
      set({ error: error.message, postCallsLoading: false });
    }
  },
  fetchEscalationAnalytics: async (sd, ed) => {
    try {
      set({ postCallsLoading: true, error: null });
      const response = await escalationAnalytics(sd, ed);
      set({ escalationAnalyticsData: response.data, postCallsLoading: false });
    } catch (error) {
      set({ error: error.message, postCallsLoading: false });
    }
  },
  fetchRepAssignment: async () => {
    try {
      set({ postCallsLoading: true, error: null });
      const response = await repAssignment();
      set({ repData: response.data, postCallsLoading: false });
    } catch (error) {
      set({ error: error.message, postCallsLoading: false });
    }
  },
  postP1CallsAttempts: async (payload) => {
    try {
      set({ callLoading: true, error: null });
      const response = await attemptByEngagements(payload);
      set({ p1CallData: response.data, callLoading: false });
    } catch (error) {
      set({ error: error.message, callLoading: false });
    }
  },
  postW1CallsAttempts: async (payload) => {
    try {
      set({ callLoading: true, error: null });
      const response = await attemptByEngagements(payload);
      set({ w1CallData: response.data, callLoading: false });
    } catch (error) {
      set({ error: error.message, callLoading: false });
    }
  },
  postW2CallsAttempts: async (payload) => {
    try {
      set({ callLoading: true, error: null });
      const response = await attemptByEngagements(payload);
      set({ w2CallData: response.data, callLoading: false });
    } catch (error) {
      set({ error: error.message, callLoading: false });
    }
  },
  postW3CallsAttempts: async (payload) => {
    try {
      set({ callLoading: true, error: null });
      const response = await attemptByEngagements(payload);
      set({ w3CallData: response.data, callLoading: false });
    } catch (error) {
      set({ error: error.message, callLoading: false });
    }
  },
  postW4CallsAttempts: async (payload) => {
    try {
      set({ callLoading: true, error: null });
      const response = await attemptByEngagements(payload);
      set({ w4CallData: response.data, callLoading: false });
    } catch (error) {
      set({ error: error.message, callLoading: false });
    }
  },
  postW5CallsAttempts: async (payload) => {
    try {
      set({ callLoading: true, error: null });
      const response = await attemptByEngagements(payload);
      set({ w5CallData: response.data, callLoading: false });
    } catch (error) {
      set({ error: error.message, callLoading: false });
    }
  },
  postW6CallsAttempts: async (payload) => {
    try {
      set({ callLoading: true, error: null });
      const response = await attemptByEngagements(payload);
      set({ w6CallData: response.data, callLoading: false });
    } catch (error) {
      set({ error: error.message, callLoading: false });
    }
  },
}));